export default function WhyNowSection() {
  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="bg-gradient-to-br from-gray-900 to-gray-800 text-white rounded-xl shadow-2xl p-6 md:p-10 lg:p-16 mb-12">
          <div className="mb-8 text-center">
            <h3 className="text-3xl md:text-4xl font-bold text-amber-400 mb-2">
              追伸
            </h3>
            <div className="w-24 h-1 bg-amber-400 rounded-full mx-auto"></div>
          </div>

          <div className="space-y-8 mb-10 text-center">
            <p className="text-xl md:text-2xl font-bold text-amber-400">
              今回は、ただ「知って終わり」の話ではありません。
            </p>
            <p className="text-xl md:text-2xl leading-relaxed">
              この面談は、あなたの人生に少しでもゆとりが生まれるきっかけをつくるための時間です。
            </p>
            <p className="text-xl md:text-2xl leading-relaxed">
              正直に言えば、私たちはまだ知名度の高い会社ではありません。それでも、本気で向き合い、誠実に取り組んでいます。
            </p>
            <p className="text-base md:text-2xl leading-relaxed">
              派手なことは言えませんが、<br className="hidden md:block" />
              あなたと同じ目線で、一緒に考えていきたい。<br className="hidden md:block" />
              そう思っています。
            </p>
            <p className="text-base md:text-2xl leading-relaxed">
              <strong className="text-amber-400">【家賃ゼロ太郎くん】</strong>を通じて、<br className="hidden md:block" />
              毎月当たり前に払っていた家賃が、<br className="hidden md:block" />
              少しでも軽くなるお手伝いをします。
            </p>
            <p className="text-base md:text-2xl leading-relaxed">
              無理な勧誘はしません。<br className="hidden md:block" />
              合わなければ、その場で断っていただいて構いません。
            </p>
            <p className="text-base md:text-2xl leading-relaxed">
              今回私は多くの方に知っていただきたい、<br className="hidden md:block" />
              利用していただきたいと本気で思っています。
            </p>
            <p className="text-xl md:text-2xl font-bold">
              まずは一度、話を聞くだけでも大丈夫です。
            </p>
            <p className="text-xl md:text-2xl font-bold text-amber-400">
              あなたの明るい未来を創るお手伝いさせてください。
            </p>
          </div>

          <a
            href="https://form.run/@yachinzero"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full inline-flex items-center justify-center gap-2 md:gap-3 flex-wrap bg-gradient-to-r from-amber-500 to-amber-600 text-white py-5 md:py-6 rounded-lg text-base md:text-xl font-bold hover:from-amber-600 hover:to-amber-700 transition-all shadow-xl hover:shadow-2xl transform hover:scale-[1.02] cursor-pointer border-2 border-white/20 whitespace-nowrap"
          >
            <i className="ri-calendar-check-line text-xl md:text-2xl"></i>
            今すぐ個人面談(無料)に申し込む
          </a>
        </div>


      </div>
    </section>
  );
}